import { HabitSchedule } from '@griply/types';

export type ScheduleSplitOptions = {
  originalScheduleEndDate: Date;
};

export const applyScheduleEdit = (
  schedules: HabitSchedule[],
  editingSchedule: HabitSchedule,
  submittedSchedule: HabitSchedule,
  splitOptions?: ScheduleSplitOptions,
): HabitSchedule[] => {
  const targetStart = editingSchedule.startDate.getTime();
  const matchIndex = schedules.findIndex(
    (schedule) => schedule.startDate.getTime() === targetStart,
  );

  if (matchIndex === -1) {
    return schedules;
  }

  if (splitOptions) {
    const originalUpdated: HabitSchedule = {
      ...editingSchedule,
      endDate: splitOptions.originalScheduleEndDate,
    };
    const next = schedules.map((schedule, index) =>
      index === matchIndex ? originalUpdated : schedule,
    );
    next.push(submittedSchedule);
    return next;
  }

  return schedules.map((schedule, index) =>
    index === matchIndex ? submittedSchedule : schedule,
  );
};
